var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.filterKeys.length
    ? _c(
        "div",
        { staticClass: "filter-selected" },
        [
          _vm._l(_vm.filterKeys, function (key) {
            return [
              _vm.selectedFilters[key]
                ? [
                    _vm._l(_vm.selectedFilters[key], function (value) {
                      return _vm.getFilter(key)
                        ? [
                            _vm.getFilter(key).type ===
                            _vm.constants.filterType.colors
                              ? [
                                  _c("sal-filter-swatch-element", {
                                    attrs: {
                                      status: _vm.constants.swatchStatus.remove,
                                      name: key,
                                      swatches: _vm.getOption(
                                        _vm.getFilter(key),
                                        value
                                      ),
                                    },
                                  }),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "remove-filter",
                                      class: _vm.themeClass(key),
                                      on: {
                                        click: function ($event) {
                                          return _vm.remove(key, value)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.displayValue(key, value)
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "icon-remove",
                                      }),
                                    ]
                                  ),
                                ],
                          ]
                        : _vm._e()
                    }),
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }